import { PrimarySDKFunctions } from '@fiverr-private/primary_section_sdk';

const shouldDisplayDefaultPrimary: PrimarySDKFunctions['shouldDisplayPrimary'] = async (_args) => ({
    shouldDisplayPrimary: true,
});

const enrichDefaultPrimaryData: PrimarySDKFunctions['enrichPrimaryData'] = async (_args) => ({
    biEnrichment: {
        componentType: 'default',
    },
});

const enrichDefaultPrimaryFallbackData: PrimarySDKFunctions['enrichFallbackPrimaryData'] = (_args) => ({
    biEnrichment: {
        componentType: 'default',
    },
});

export const PrimaryDefaultSDKFunctionsImpl: PrimarySDKFunctions = {
    shouldDisplayPrimary: shouldDisplayDefaultPrimary,
    enrichPrimaryData: enrichDefaultPrimaryData,
    enrichFallbackPrimaryData: enrichDefaultPrimaryFallbackData,
};
